import React from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import {
  addPositionTitle,
  updatePositionTitle,
} from "../../../actions/MasterDataActions/positionTitleActions";

function PositionTitleForm(props) {
  const { updateData, isCreate, handleClose } = props;
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();
  const onSubmit = (data) => {
    if (isCreate) {
      dispatch(addPositionTitle({ title: data.title, status: data?.status }));
    } else {
      // if (data.name !== updateData.name) {
      dispatch(
        updatePositionTitle({
          title: data.title,
          positionSlug: updateData.slug,
          status: data?.status,
        })
      );
      // }
    }
    handleClose();
  };

  return (
    <div>
      <Container>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Form.Group as={Row} controlId="title">
            <Form.Label column sm="3" className="font-semi-bold-TKL">
              Position Title<span className="text-danger">*</span>
            </Form.Label>
            <Col sm="9">
              <Form.Control
                name="title"
                type="text"
                size="sm"
                defaultValue={updateData.title ? updateData.title : ""}
                placeholder="Enter Position Title"
                className="rounded-pill"
                {...register("title", { required: true })}
              />

              {errors.title && (
                <p className="show-txt-error p-1 m-2">
                  Position Title is required
                </p>
              )}
            </Col>
          </Form.Group>
          <Form.Group as={Row} controlId="status">
            <Form.Label column sm="3" className="font-semi-bold-TKL">
              Status
            </Form.Label>
            <Col sm="9" className="select-container">
              <span className="select-arrow-icon material-icons">
                expand_more
              </span>

              <Form.Control
                {...register("status", { required: true })}
                as="select"
                size="sm"
                className="rounded-pill select-styles"
                defaultValue={
                  updateData?.status ? updateData?.status : "INACTIVE"
                }
              >
                <option name="INACTIVE">INACTIVE</option>
                <option name="ACTIVE">ACTIVE</option>
              </Form.Control>
            </Col>
          </Form.Group>
          <Form.Group as={Row} controlId="button">
            <Row className="mt-3 mr-2 ml-auto mr-3s">
              <Button
                className="m-2 btn btn-secondary rounded-pill"
                onClick={handleClose}
              >
                Close
              </Button>
              <Button
                type="submit"
                className="m-2 btn btn-primary rounded-pill"
                disabled={
                  !isCreate &&
                  (watch("title") === "Other" ||
                    updateData?.title === "Other") &&
                  true
                }
              >
                {isCreate ? "Create" : "Update"}
              </Button>
            </Row>
          </Form.Group>
        </form>
      </Container>
    </div>
  );
}

export default PositionTitleForm;
